document.addEventListener('DOMContentLoaded', () => {

  $(document).on('click', '.modal-close, .modal-delete, .modal-hide', function(){
    $('.modal').removeClass('is-active')
  });
  
})
